import { render } from "./RemaindStock.vue?vue&type=template&id=07f39256&scoped=true"
import script from "./RemaindStock.vue?vue&type=script&lang=js"
export * from "./RemaindStock.vue?vue&type=script&lang=js"

import "./RemaindStock.vue?vue&type=style&index=0&id=07f39256&scoped=true&lang=css"
import "./RemaindStock.vue?vue&type=style&index=1&id=07f39256&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f39256"]])

export default __exports__